import React, { useEffect, useRef } from "react";

import { useQuery } from "react-query";
import { getEventConsumptionByEventIDAndRange } from "../actions";

import {
  AreaChart,
  Area,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from "recharts";
import { addCommasToNum } from "../utils";

const DetailedLineChart = ({
  eventID,
  clientID,
  startDate,
  endDate,
  setSingleEventDetails,
}) => {
  const { data, isError, refetch } = useQuery({
    queryKey: `eventConsumptionByRange`,
    queryFn: () =>
      getEventConsumptionByEventIDAndRange({
        clientID,
        startDate,
        eventID,
        endDate,
      }),
    placeholderData: [],
    onSuccess: (data) => setSingleEventDetails(data),
  });

  const firstUpdate = useRef(true);
  useEffect(() => {
    if (firstUpdate.current) {
      firstUpdate.current = false;
      return;
    }

    refetch();
  }, [eventID, startDate, endDate]);

  if (isError) return <div className="error">Error loading data</div>;

  return (
    <ResponsiveContainer width="100%" height={400}>
      <AreaChart
        data={data}
        margin={{
          top: 5,
          left: 5,
          right: 5,
          bottom: 5,
        }}
      >
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="dateLabel" />
        <YAxis tickFormatter={(val) => addCommasToNum(val, 3, 0)} />
        <Tooltip />
        <Area
          type="monotone"
          dataKey="Live Consumption"
          stackId="1"
          unit={" GB"}
          stroke="rgba(0, 162, 255, 0.8)"
          fill="rgba(0, 162, 255, 0.8)"
        />
        <Area
          type="monotone"
          dataKey="Vod Consumption"
          stackId="1"
          unit={" GB"}
          stroke="rgba(255, 159, 64, 0.8)"
          fill="rgba(255, 159, 64, 0.8)"
        />
      </AreaChart>
    </ResponsiveContainer>
  );
};

export default DetailedLineChart;
